<template>
  <div
    class="pre-report">
    <div class="pre-report__title-wrap">
      <div class="pre-report__title">
        <svg
          class="icon-pre_report svg-icon"
          viewBox="0 0 27.49 21.276">
          <path
            class="color1"
            d="M4.8 0C3.2 0 2 1.2 2 2.8v15.7c0 1.6 1.2 2.8 2.8 2.8h18c1.6 0 2.8-1.2,
             2.8-2.8V2.8C25.6 1.2 24.4 0 22.8 0h-18zm0 2h18c.4 0 .8.4.8.8v15.7c0,
              .4-.4.8-.8.8h-18c-.4 0-.8-.4-.8-.8V2.8c0-.4.4-.8.8-.8zm8.2,
               4v5.6h-2.5l3.5 3.5 3.5-3.5h-2.5V6h-2zm-4 10v2h10v-2h-10z" />
        </svg>
        支払調書
      </div>
    </div>
    <div class="pre-report__body">
      <span
        v-if="files.length === 0"
        style="color: #6D6D6D; font-size: 14px">
        令和{{ eraYear }}年にお支払いが発生していないため、支払調書の発行はございません。
      </span>
      <template v-else>
        <div
          style="margin-top:-5px;margin-bottom: 10px">
          令和{{ eraYear }}年分の支払調書はこちらからダウンロードできます
        </div>
        <div class="pre-report__item-wrap">
          <div
            class="pre-report__item"
            style="margin-top: 9px">
            <button
              v-for="file in files"
              :key="file.name"
              class="c-btn"
              style="width: 300px; margin-right: 12px"
              @click.prevent="downloadFile(file.file_id, file.name)">
              {{ file.name }}
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver'

export default {
  name: 'PaymentRecord',
  components: {},
  props: {
  },
  data() {
    return {
      files: [],
      eraYear: 6,
    }
  },
  mounted() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      const { data } = await window.axios.get('/api/client/payments/record-files')
      this.files = data
      if (this.files.length > 0) {
        this.eraYear = this.files[0].era_year
      }
    },
    async downloadFile(fileId, fileName, openInBrowser = false) {
      try {
        const response = await window.axios.get('/api/client/payments/record-file', {
          params: {
            file_id: fileId,
          },
          responseType: 'blob',
        })
        const blob = new Blob([response.data], {
          type: response.data.type,
        })
        // ブラウザで開く
        if (openInBrowser) {
          const fileURL = window.URL.createObjectURL(blob)
          const anchor = document.createElement('a')
          anchor.href = fileURL
          anchor.target = '_blank'
          anchor.click()
        } else {
          const fileSuffix = this.$store.state.auth.company.name
          saveAs(blob, `${fileSuffix}-${fileName}.pdf`)
        }
      } catch (e) {
        this.error = e.message
      }
    },
  },
}
</script>

<style scoped>
.pre-report__body{
  background-color: #ffffff;
  display: flex;
  align-items: center;
  flex: inherit;
  flex-wrap: wrap;
  padding: 10px;
  width: 100%;
}

</style>
